// extracted by mini-css-extract-plugin
export default {"StepNumber":"StepNumber_StepNumber__lJ1wg"};